<template>
  <b-container>
    <div v-for="(value, key) in flags" :key="key">
      <label v-if="key != 'voucher'">
        <input class="browser-default" type="checkbox" :checked="flags[key]"
          @change="toggle(key)">
        {{key}}
      </label>
    </div>
    <label style="display: block;">voucher: <input type="text" :value="flags.voucher" @input="setVoucher"></label>
    <b-button class="reload-btn" v-if="needsReload" @click="reload">Reload Page</b-button>
    <b-button variant="clear" @click="resetFlags">Reset Flags</b-button>
    <b-button variant="clear" v-if="isStaff" @click="saveTeamFlags">Save Team Flags</b-button>
  </b-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  props: ['flag', 'state'],
  methods: {
    ...mapActions(['updateFlags', 'resetFlags', 'saveTeamFlags']),
    toggle(key) {
      this.updateFlags({[key]: !this.flags[key]});
    },
    reload() {
      window.location.reload();
    },
    setVoucher(event) {
      this.updateFlags({voucher: event.target.value});
    }
  },
  computed: mapGetters(['flags', 'needsReload', 'isStaff']),
  mounted() {
    if (this.flag && this.state) {
      this.updateFlags({[this.flag]: this.state === 'on'});
      // Reload the homepage, with a full reload, just in case flags
      // affect routes or other Vue initialization logic.
      window.location = '/';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/flags/Flags.vue